import request from '@/utils/request'

let NoticeApi = {

  /*公告管理*/
  noticeList(data, errorback) {
    return request._post('/shop/setting.notice/index', data, errorback);
  } ,
  hasUnreadNotice(data, errorback) {
    return request._post('/shop/setting.notice/hasUnreadNotice', data, errorback);
  } ,
  readNotice(data, errorback) {
    return request._post('/shop/setting.notice/read', data, errorback);
  } ,
  readAllNotice(data, errorback) {
    return request._post('/shop/setting.notice/readAll', data, errorback);
  }
}

export default NoticeApi;



// WEBPACK FOOTER //
// ./src/api/notice.js